import React from "react";
import IconCross from "./../Icons/IconCross";
import "./Content.scss";
import {Link} from 'react-router-dom'
 
const Content = ({ movie, onClose }) => (
  <div className="content">
    <div className="content__background">
      <div className="content__background__shadow" />
      <div
        className="content__background__image"
        style={{ backgroundImage: `url(${movie.image_url})` }}
      />
    </div>
    <div className="content__area">
      {movie.rating ? (
        <div className="content__area__container">
          <div className="content__title">{movie.title}</div>
          <div className="content__description">{movie.description}</div>
          <div className="content__year">Release : {movie.year}</div>
          <div className="content__duration">Duration : {movie.duration} Minutes</div>
          <div className="content__genre">Genre : {movie.genre}</div>
          <div className="content__rating">Rating : {movie.rating}/10</div>
          <div className="content__read_more"><span><Link to={"/movie/"+movie.id}>Read More ...</Link></span></div>          
        </div>
      ) : (
        <div className="content__area__container">
          <div className="content__title">{movie.name}</div>
          <div className="content__genre">{movie.genre}</div>
          <div className="content__type">
            Mode: {movie.singlePlayer == 1 && movie.multiPlayer == 1 ? "Single Player, MultiPlayer " :movie.singlePlayer == 1?"Single Player":movie.multiPlayer == 1?"Multi Player":"" }
          </div>
          <div className="content__platform">Platform : {movie.platform}</div>
          <div className="content__release">Release : {movie.release}</div>
          <div className="content__read_more"><span><Link to={"/game/"+movie.id}>Read More ...</Link></span></div>
        </div>
      )}

      <button className="content__close" onClick={onClose} style={{cursor:"pointer"}}>
        <IconCross />
      </button>
    </div>
  </div>
);

export default Content;
